import React, {useRef} from "react"

import UsersToAdd from "../../users/model/collection"
import {AddUser_Manager} from "../../users/model/manager"
import {AddUserType} from "../../users/@const"
import UserToAdd from "../../users/model/add-user"
import {ProjectAccess} from "../../../gd/const/project"
import {ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import {AddUser_createProjectUsers, AddUser_createWorkspaceUsers} from "../../users/actions/create-users"
import HelpBlock, {HelpType} from "../../../gd-components/help-and-hint/help-block/help-block"
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import Modal_addUsers from "./add-users"
import Modal_Submit from "../submit/submit"
import {MissingUsersTeamsManagerInterface} from "./missing-users-teams-manager-interface"
import {ModalMoveTo_MissingUsersTeams} from "../../move-to/actions/get-missing-users-and-teams";
import ProjectSession from "../../../model2/project/project-session";
import Modal_addTeams from "./add-teams";
import TeamsToAdd from "../../teams/model/collection";
import {AddTeam_Manager} from "../../teams/model/manager";
import {AddTeamType} from "../../teams/@const";
import {TeamToAdd} from "../../teams/model/add-team";
import {AddTeam_createProjectTeams, AddTeam_createWorkspaceTeams} from "../../teams/actions/create-teams";
import getSubmitButtonLabel from "../actions/get-submit-button-label";

type Props = {
    manager: MissingUsersTeamsManagerInterface
}

// const debug = "Modal_AddMissingUsers"
const debug = false

export default function Modal_AddMissingUsersTeams(props: Props) {

    const refSubmitButton: any = useRef()

    const users: ModalMoveTo_MissingUsersTeams = props.manager.missingUsersTeams!

    const targetProject: ProjectSession = props.manager.targetProject!
    const showProjectAccess: boolean    = props.manager.showProjectAccess

    const defaultWorkspaceAccess  : ProjectAccess = ProjectAccess.STANDARD
    const defaultProjectAccess    : ProjectAccess = ProjectAccess.STANDARD

    const teamsToAddToWorkspace = new TeamsToAdd(new AddTeam_Manager(AddTeamType.WORKSPACE_TEAM))
    const teamsToAddToProject = new TeamsToAdd(new AddTeam_Manager(AddTeamType.PROJECT_TEAM))

    const usersToAddToWorkspace = new UsersToAdd(new AddUser_Manager(AddUserType.WORKSPACE_USER))
    const usersToAddToProject = new UsersToAdd(new AddUser_Manager(AddUserType.WORKSPACE_USER))

    // props.manager.type poka ne ispolzuetsya!!!
    debug && console.log(debug, "Type: ", props.manager.type)

    if (targetProject?.workspace) {

        _.map(users.workspaceTeamIds, (teamId: ID)=> {
            const team = gd.session.teams.get(teamId)
            if (team) {
                const teamToAdd = new TeamToAdd(team)
                teamToAdd.workspaceAccess   = defaultWorkspaceAccess
                teamToAdd.projectAccess     = defaultProjectAccess
                teamToAdd.isSelected        = true
                teamsToAddToWorkspace.add(teamToAdd)
            }
        })

        _.map(users?.workspaceUserIds, (userId:ID)=>{
            const companyUser = gd.session.companyUsers.getByUserId(userId)
            if (companyUser) {
                const userToAdd = new UserToAdd(companyUser)
                userToAdd.workspaceAccess   = defaultWorkspaceAccess
                userToAdd.projectAccess     = defaultProjectAccess
                userToAdd.isSelected        = true
                usersToAddToWorkspace.add(userToAdd)
            }
        })
    }

    // _.map(users.projectTeamIds, (teamId: ID)=> {
    //     const team = gd.session.teams.get(teamId)
    //     if (team) {
    //         const teamToAdd = new TeamToAdd(team)
    //         teamToAdd.workspaceAccess   = defaultWorkspaceAccess
    //         teamToAdd.projectAccess     = defaultProjectAccess
    //         teamToAdd.isSelected        = true
    //         teamsToAddToProject.add(teamToAdd)
    //     }
    // })

    _.map(users?.projectUserIds, (userId:ID)=>{
        if (targetProject?.workspace && users?.workspaceUserIds.includes(userId)) {
            // skip
            return
        }

        const companyUser = gd.session.companyUsers.getByUserId(userId)
        if (companyUser) {
            const userToAdd  = new UserToAdd(companyUser)
            userToAdd.projectAccess     = defaultProjectAccess
            userToAdd.isSelected        = true
            usersToAddToProject.add(userToAdd)
        }
    })

    const onSubmit = async () => {
        debug && console.log(debug, 'onSubmit', usersToAddToWorkspace.available, usersToAddToProject.available)
        debug && console.log(debug, 'onSubmit', teamsToAddToWorkspace.available, teamsToAddToProject.available)

        refSubmitButton.current.setType(ButtonType.BUSY)

        if (targetProject?.workspace && !teamsToAddToWorkspace.isEmpty) {
            await AddTeam_createWorkspaceTeams(targetProject.workspace, teamsToAddToWorkspace)

            if (showProjectAccess) {
                await AddTeam_createProjectTeams(targetProject, teamsToAddToProject)
            }
        }

        // Nujen li voobshe eto??? U TASK, MEETING, DOCUMENT net teams. A esli MULTI ???

        // if (!teamsToAddToProject.isEmpty && targetProject) {
        //     await AddTeam_createProjectTeams(targetProject, teamsToAddToProject)
        // }

        if (targetProject?.workspace && !usersToAddToWorkspace.isEmpty) {
            await AddUser_createWorkspaceUsers(targetProject?.workspace, usersToAddToWorkspace)

            // add project users only it is required
            if (showProjectAccess) {
                await AddUser_createProjectUsers(targetProject, usersToAddToWorkspace)
            }
        }

        if (!usersToAddToProject.isEmpty && targetProject) {
            await AddUser_createProjectUsers(targetProject, usersToAddToProject)
        }

        props.manager.commit()
    }

    debug && console.log(debug, 'render', usersToAddToWorkspace, usersToAddToProject)

    const usersLength = usersToAddToWorkspace.length + usersToAddToProject.length
    // const teamsLength = teamsToAddToWorkspace.length + teamsToAddToProject.length
    const teamsLength = teamsToAddToWorkspace.length

    let submitButtonLabel = getSubmitButtonLabel(usersLength, teamsLength);

    const importantNotification = 'Some users are not present in the target {0}, and you need to add them.'.f(showProjectAccess ? 'workspace/project' : 'workspace')

    return (
        <>
            <div className="w-100-percent p-l-30 p-r-30 border-box">
                <HelpBlock type = {HelpType.IMPORTANT}>
                    {importantNotification}
                </HelpBlock>
            </div>

            <VScroll className="central-container" containerClass="p-l-30 p-t-20 p-r-30">

                {/*{(!teamsToAddToProject.isEmpty || !teamsToAddToWorkspace.isEmpty) && (*/}
                {(!teamsToAddToWorkspace.isEmpty) && (
                    <Modal_addTeams targetProject         = {targetProject}
                                    showProjectAccess     = {showProjectAccess}
                                    showWorkspaceAccess   = {usersToAddToWorkspace.available.length > 0}
                                    teamsToAddToWorkspace = {teamsToAddToWorkspace}
                                    teamsToAddToProject   = {teamsToAddToProject}/>
                )}

                {(!usersToAddToProject.isEmpty || !usersToAddToWorkspace.isEmpty) && (
                    <Modal_addUsers targetProject         = {targetProject}
                                    showProjectAccess     = {showProjectAccess}
                                    showWorkspaceAccess   = {usersToAddToWorkspace.available.length > 0}
                                    usersToAddToWorkspace = {usersToAddToWorkspace}
                                    usersToAddToProject   = {usersToAddToProject}/>
                )}

            </VScroll>

            <Modal_Submit ref       = {refSubmitButton}
                          type      = {ButtonType.PRIMARY}
                          label     = {submitButtonLabel}
                          onSubmit  = {onSubmit}/>
        </>
    )
}
